/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Manages fields, a replacement for JSON Schema.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "string",
    title: "String",
    description: "A field representing a string value with optional min, max, and pattern.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    alias: "text",
    fields: {
        min: {
            title: "Minimum Length",
            description: "The minimum number of characters allowed.",
            type: "number"
        },
        max: {
            title: "Maximum Length",
            description: "The maximum number of characters allowed.",
            type: "number"
        },
        pattern: {
            title: "Pattern",
            description: "A regular expression pattern that the string must match.",
            type: "string"
        }
    },
    tests: {
        valid: {
            must: true,
            run: function () {
                return validate({ title: "Name", type: "string", min: 2, max: 6 }, "Hello");
            }
        },
        tooShort: {
            throw: "fields.string.tooShort",
            run: function () {
                return validate({ title: "Name", type: "string", min: 3 }, "Hi");
            }
        },
        tooLong: {
            throw: "fields.string.tooLong",
            run: function () {
                return validate({ title: "Name", type: "string", max: 3 }, "Hello");
            }
        },
        patternFail: {
            throw: "fields.string.patternMismatch",
            run: function () {
                return validate({ title: "Email", type: "string", pattern: "^[a-z]+@[a-z]+\\.com$" }, "bad-email");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid String",
            description: "The value must be a string.",
            template: "Expected string but received ${typeof}"
        },
        tooShort: {
            title: "Too Short",
            description: "The string is shorter than the minimum allowed.",
            template: "Minimum length is ${min} but received ${length}"
        },
        tooLong: {
            title: "Too Long",
            description: "The string exceeds the maximum allowed length.",
            template: "Maximum length is ${max} but received ${length}"
        },
        patternMismatch: {
            title: "Pattern Mismatch",
            description: "The string does not match the required pattern.",
            template: "Pattern ${pattern} not matched by value: ${value}"
        }
    }
});

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ typeof: typeof value });
    }

    if ("min" in spec && value.length < spec.min) {
        _.errors.tooShort.throw({ min: spec.min, length: value.length });
    }

    if ("max" in spec && value.length > spec.max) {
        _.errors.tooLong.throw({ max: spec.max, length: value.length });
    }

    if ("pattern" in spec && !new RegExp(spec.pattern).test(value)) {
        _.errors.patternMismatch.throw({ pattern: spec.pattern, value: value });
    }
}
module.exports.validate = validate;
